import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
	selector: 'app-day-of-week-toggle',
	template: ` <button
		[attr.data-automation-id]="'day-of-the-week-toggle-' + label + '-button'"
		class="reoccurrence-toggle"
		[disabled]="disabled"
		[ngClass]="{ selected: selection }"
		(click)="toggleSelected()"
	>
		{{ label }}
	</button>`,
	styleUrls: ['./day-of-week-toggle.component.scss'],
	imports: [NgClass],
})
export class DayOfWeekToggleComponent {
	@Input() label = '';
	@Input() selection = false;
	@Input() disabled = false;

	@Output() selectionChange = new EventEmitter<boolean>();

	toggleSelected(): void {
		this.selection = !this.selection;
		this.selectionChange.emit(this.selection);
	}
}
